import EmptyResults from 'components/EmptyResults'
import { Button, Icon, List, Typography } from 'gu-ui-kit'
import React from 'react'
import { useTableConfig } from 'modules/Referral/ReferralClients/subcomponents/Table/hooks/useTableConfig'
import PropTypes from 'prop-types'
import { ReactComponent as EmptyResultsSVG } from 'images/illustration/no-referrals.svg'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'

export const Table = ({ data, handleChangeName }) => {
  const { t } = useTranslation()
  const breakpoints = useBreakpoint()
  const pathGen = useGeneratePathI18n()

  const { tableState, tableConfig } = useTableConfig(
    {
      handleChangeName,
    },
    data,
  )
  return (
    <List
      table={tableState}
      config={tableConfig}
      EmptyComponent={() => (
        <EmptyResults
          header={t('referral::referral_clients.table.empty_list.heading')}
          text={
            <Typography variant={'Body-25'} color={'Label-Fifth'}>
              {t('referral::referral_clients.table.empty_list.summary')}
            </Typography>
          }
          image={<EmptyResultsSVG />}
          actionButton={
            <Button
              fullWidth={breakpoints.fbs}
              variant={'primary'}
              component={Link}
              to={pathGen(ROUTES.REFERRAL_LINKS_CREATE)}
              size="l"
              startIcon={<Icon name={'plus'} />}
            >
              {t('referral::referral_links.create_link')}
            </Button>
          }
        />
      )}
    />
  )
}

Table.propTypes = {
  handleChangeName: PropTypes.func,
  data: PropTypes.array,
}
